export default {
    "registerSubscription": "8aea44b0eb692836b58bf5c1b9d386422bef8a41d423a32d2cf495888d858cab",
    "pushNotification": "90e362358d618b89aedd5bf04df7ae3224152cbeea79792cbaba7a90cd2d6f68"
};
